<!-- 店家專區：/merchant -->
<template>
  <div class="layout_wrapper">
    <section class="section1">
      <div class="container">
        <div class="section_wrapper">
          <div class="section_info">
            <h2 class="section1_title">
              支付雙平台曝光
              <br>
              開發潛在用戶海
            </h2>

            <p class="section1_description">
              全支付、PXPay 雙APP流量共享輕鬆觸及千萬潛在用戶
            </p>

            <CustomActionBtn
              btn-text="申請成為合作店家"
              :btn-width="245"
              @click="gotoApplyPage"
            />
          </div>

          <div class="section_pic">
            <picture>
              <source
                media="(min-width: 768px) and (max-width: 1024px)"
                :srcset="require('@/assets/imgs/merchant/section1_phone@2x.png')"
              >
              <source
                media="(max-width: 414px)"
                :srcset="require('@/assets/imgs/merchant/section1_phone.png')"
              >
              <img
                class="section_phone_img"
                :srcset="require('@/assets/imgs/merchant/section1_phone@3x.png')"
              >
            </picture>
          </div>
        </div>
      </div>
    </section>

    <section class="section2">
      <div class="container">
        <swiper
          slides-per-view="auto"
          :loop="true"
          :space-between="30"
          :allow-touch-move="false"
          :navigation="{
            nextEl: '.section2_arrow_right',
            prevEl: '.section2_arrow_left',
          }"
        >
          <swiper-slide>
            <div class="section_wrapper">
              <div class="section_pic">
                <picture>
                  <source
                    media="(min-width: 768px) and (max-width: 1024px)"
                    :srcset="require('@/assets/imgs/merchant/section2_pic1@2x.png')"
                  >
                  <source
                    media="(max-width: 414px)"
                    :srcset="require('@/assets/imgs/merchant/section2_pic1.png')"
                  >
                  <img
                    class="section_img"
                    :srcset="require('@/assets/imgs/merchant/section2_pic1@3x.png')"
                  >
                </picture>
              </div>

              <div class="section_info">
                <h4 class="section_info_title">
                  支付整合，店家收款更省心
                </h4>

                <p class="section_info_des">
                  快速結帳免找零，顧客付款輕鬆、店家收款省時。
                </p>
              </div>
            </div>
          </swiper-slide>

          <swiper-slide>
            <div class="section_wrapper">
              <div class="section_pic">
                <picture>
                  <source
                    media="(min-width: 768px) and (max-width: 1024px)"
                    :srcset="require('@/assets/imgs/merchant/section2_pic2@2x.png')"
                  >
                  <source
                    media="(max-width: 414px)"
                    :srcset="require('@/assets/imgs/merchant/section2_pic2.png')"
                  >
                  <img
                    class="section_img"
                    :srcset="require('@/assets/imgs/merchant/section2_pic2@3x.png')"
                  >
                </picture>
              </div>

              <div class="section_info">
                <h4 class="section_info_title">
                  會員整合，提升用戶付款體驗
                </h4>

                <p class="section_info_des">
                  會員積點免實體卡，支付 + 累點一嗶搞定！
                </p>
              </div>
            </div>
          </swiper-slide>
        </swiper>

        <button class="swiper_arrow swiper_arrow_left section2_arrow_left" />
        <button class="swiper_arrow swiper_arrow_right section2_arrow_right" />
      </div>
    </section>

    <section class="section3">
      <div class="container">
        <div class="section_wrapper">
          <div class="section_info">
            <h4 class="section_info_title">
              專屬管理後台，經營更聰明
            </h4>

            <ul class="section_info_list">
              <li>1. 交易筆筆詳細列表，結算有效率。</li>
              <li>2. 報表免登入自動寄送，請款更省力。</li>
              <li>3. 權限設定管理，專人專職分工更明確。</li>
            </ul>
          </div>

          <div class="section_pic special_section3_pic">
            <picture>
              <source
                media="(min-width: 768px) and (max-width: 1024px)"
                :srcset="require('@/assets/imgs/merchant/section3_pic1@2x.png')"
              >
              <source
                media="(max-width: 414px)"
                :srcset="require('@/assets/imgs/merchant/section3_pic1.png')"
              >
              <img
                class="section_img special_section3_img_size"
                :srcset="require('@/assets/imgs/merchant/section3_pic1@3x.png')"
              >
            </picture>
          </div>
        </div>
      </div>
    </section>

    <section class="section4">
      <div class="container">
        <div class="section_pic special_section4_pic">
          <div class="section4_num">
            {{ `0${section4CurrentIdx+1}` }}
          </div>

          <transition
            v-for="item in 2"
            :key="item"
            name="fade"
          >
            <picture v-show="section4CurrentIdx + 1 === item">
              <source
                media="(min-width: 768px) and (max-width: 1024px)"
                :srcset="require(`@/assets/imgs/merchant/section4_pic${item}@2x.png`)"
              >
              <source
                media="(max-width: 414px)"
                :srcset="require(`@/assets/imgs/merchant/section4_pic${item}.png`)"
              >
              <img
                class="section_img special_section4_img_size"
                :srcset="require(`@/assets/imgs/merchant/section4_pic${item}@3x.png`)"
              >
            </picture>
          </transition>
        </div>

        <swiper
          slides-per-view="auto"
          :allow-touch-move="false"
          :direction="windowWidth >= 1024 ? 'vertical' : 'horizontal'"
          :loop="true"
          :mousewheel="{ releaseOnEdges: true, sensitivity: 0.5 }"
          :navigation="{ nextEl: '.section4_arrow_right', prevEl: '.section4_arrow_left',}"
          :scrollbar="{el: '.section4_scrollbar'}"
          @swiper="onSection4Slide"
          @slideChangeTransitionStart="changeSection4Slide"
          @resize="resizeSection4"
        >
          <swiper-slide>
            <div class="section_wrapper">
              <div class="section_info">
                <div class="section4_num">
                  01
                </div>

                <h4 class="section_info_title">
                  品牌專區，建立專屬形象
                </h4>

                <p class="section_info_des">
                  客制化品牌資訊，不定期全支付主題活動加碼優惠，媒體強效宣傳。
                </p>
              </div>
            </div>
          </swiper-slide>

          <swiper-slide>
            <div class="section_wrapper">
              <div class="section_info">
                <div class="section4_num">
                  02
                </div>

                <h4 class="section_info_title">
                  多重平台，導引流量曝光
                </h4>

                <p class="section_info_des">
                  共享全支付、PXPay 雙平台流量，宣傳效果更加乘！
                </p>
              </div>
            </div>
          </swiper-slide>
        </swiper>

        <div class="section4_scrollbar" />
        <button class="swiper_arrow swiper_arrow_left section4_arrow_left" />
        <button class="swiper_arrow swiper_arrow_right section4_arrow_right" />
      </div>
    </section>

    <section class="section5">
      <div class="container">
        <div class="section_wrapper">
          <div class="section_info">
            <h4 class="section_info_title">
              最安心的支付平台
            </h4>

            <p class="section_info_des">
              專業安全防護認證，顧客輕鬆PAY，收款安心GET
            </p>
          </div>

          <div class="section_pic">
            <picture>
              <source
                media="(min-width: 768px) and (max-width: 1024px)"
                :srcset="require('@/assets/imgs/merchant/section5_pic1@2x.png')"
              >
              <source
                media="(max-width: 414px)"
                :srcset="require('@/assets/imgs/merchant/section5_pic1.png')"
              >
              <img
                class="section_img"
                :srcset="require('@/assets/imgs/merchant/section5_pic1@3x.png')"
              >
            </picture>
          </div>
        </div>
      </div>
    </section>

    <section class="section6">
      <div class="section_wrapper">
        <div class="section6_info">
          <a
            class="merchant_activity_link"
            href="https://marketing.pxpayplus.com/pxplus_marketing_page/event?EventId=26"
            target="_blank"
          >
            店家募集中
          </a>

          <CustomActionBtn
            btn-text="申請成為合作店家"
            :btn-width="250"
            @click="gotoApplyPage"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { ref, nextTick } from 'vue';
import SwiperCore, { Autoplay, Mousewheel, Navigation, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { setGaEvent } from '@/libs/global';
import CustomActionBtn from '@/components/Layout/CustomActionBtn';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/scrollbar/scrollbar.scss';

export default {
  name: 'Merchant',
  components: {
    Swiper,
    SwiperSlide,
    CustomActionBtn
  },
  setup () {
    SwiperCore.use([Autoplay, Mousewheel, Navigation, Scrollbar]);

    const section4Slide = ref(null);
    const section4CurrentIdx = ref(1);
    const windowWidth = ref(window.innerWidth);

    const gotoApplyPage = () => {
      setGaEvent('merchant_apply', { apply: 'click' });

      window.open('https://pxpayplus.surveycake.biz/s/NqxZk');
    };

    const changeSection4Slide = (swiper) => {
      section4CurrentIdx.value = swiper.realIndex;

      if (windowWidth.value < 1024) return;

      nextTick(() => {
        const section4Drag = document.querySelector('.swiper-scrollbar-drag');
        const dragHeight = windowWidth.value > 1439 ? 180 : 90;

        section4Drag.style.transform = `translate3d(0px, ${dragHeight * swiper.realIndex}px, 0px)`;
      });
    };

    const resizeSection4 = (swiper) => {
      windowWidth.value = window.innerWidth;

      swiper.changeDirection(windowWidth.value >= 1024 ? 'vertical' : 'horizontal');
    };

    const onSection4Slide = (swiper) => {
      section4Slide.value = swiper;
    };

    nextTick(() => {
      const callback = (entry, observer) => {
        if (section4Slide.value.realIndex === 0 || windowWidth.value < 1024) return;

        if (!entry[0].isIntersecting) {
          section4Slide.value.slideTo(0, 0);
        }
      };

      const observer = new IntersectionObserver(callback);
      const section4Target = document.querySelector('.section4');

      observer.observe(section4Target);
    });

    return {
      windowWidth,
      gotoApplyPage,
      section4CurrentIdx,
      changeSection4Slide,
      onSection4Slide,
      resizeSection4
    };
  }
};
</script>

<style scoped lang="scss">
@import '@/scss/common/common.scss';

.layout_wrapper {
  .container {
    max-width: 1040px;
    margin: 0 auto;
    padding: 75px 0;
    position: relative;
  }

  section {
    .section_wrapper {
      align-items: center;
      display: flex;
      flex-direction: row;
    }

    .section_info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 360px;

      .section_info_title {
        @include font-size-bold-30;

        margin-top: 0;
        margin-bottom: 20px;
      }

      .section_info_des {
        @include font-size-18;

        color: $mono_80;
        margin: 0;
      }

      .section_info_list {
        @include font-size-18;

        list-style-type: none;
        margin: 0px;
        padding: 0px;

        li {
          &:not(:last-child) {
            margin-bottom: 12px;
          }
        }
      }
    }

    .section_pic {
      height: 500px;
      flex-shrink: 0;
      width: 500px;
    }

    img {
      height: auto;
      width: 100%;
      vertical-align: middle;
    }
  }

  .swiper_arrow {
    border: 0;
    cursor: pointer;
    height: 52px;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 52px;
    z-index: 9;

    &.swiper_arrow_left {
      background: url('~@/assets/imgs/common/arrow_left@3x.png')no-repeat;
      background-size: contain;
    }

    &.swiper_arrow_right {
      background: url('~@/assets/imgs/common/arrow_right@3x.png')no-repeat;
      background-size: contain;
    }
  }

  .section1 {
    overflow: hidden;

    .container {
      padding-top: 115px;
    }

    .section_info {
      width: 378px;
      margin-right: 112px;

      .section1_title {
        @include font-size-bold-54;

        margin-bottom: 20px;
        margin-top: 35px;
      }

      .section1_description {
        font-size: 36px;
        line-height: 42px;
        margin-top: 0;
        margin-bottom: 100px;
      }
    }

    .section_pic {
      position: relative;

      &::before {
        background: url('~@/assets/imgs/common/circle@3x.png')repeat-x left center/contain;
        content: '';
        height: 500px;
        left: 500px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 960px;
        z-index: -1;
      }
    }
  }

  .section2 {
    ::v-deep(.swiper-container) {
      width: 100%;

      .swiper-button-prev,
      .swiper-button-next {
        height: 52px;
        width: 52px;
      }
    }

    .container {
      position: relative;
    }

    .section_pic {
      margin-right: 100px;
    }

    .swiper_arrow_left {
      display: none;
    }

    .swiper_arrow_right {
      right: -120px;
    }
  }

  .section3 {
    .section_pic {
      align-items: center;
      display: flex;
      justify-content: center;
      margin-left: 180px;
    }

    .special_section3_pic {
      width: 498px;
      height: 369px;

      .special_section3_img_size {
        width: 100%;
      }
    }
  }

  .section4 {
    .container {
      align-items: center;
      display: flex;
    }
    .section_wrapper {
      align-items: center;
      width: 100%;

      &:not(:last-child) {
        margin-bottom: 100px;
      }
    }

    ::v-deep(.swiper-container) {
      height: 538px;
      margin: 0;
      width: 100%;

      .swiper-slide {
        align-items: center;
        display: flex;

        &:not(:last-child) {
          margin-bottom: 100px;
        }
      }
    }

    .section4_scrollbar {
      height: 360px;
      position: absolute;
      right: -150px;
      top: 50%;
      transform: translateY(-50%);
      width: 10px;

      ::v-deep(.swiper-scrollbar-drag) {
        background: $mono_20;
        height: 180px !important;
        transition: all .5s;
      }
    }

    .swiper_arrow_left,
    .swiper_arrow_right {
      display: none;
    }

    .section4_num {
      @include font-size-bold-24;

      color: $mono_80;
      margin-bottom: 30px;
      position: relative;

      &:after {
        background: #979797;
        content: '';
        height: 1px;
        position: absolute;
        top: 50%;
        left: 36px;
        transform: translateY(-50%);
        width: 41px;
      }
    }

    .section_pic {
      background: url('~@/assets/imgs/common/circle@3x.png')no-repeat center center/contain;
      height: 538px;
      margin-right: 150px;
      position: relative;
      text-align: center;
      width: 452px;

      .section4_num {
        display: none;
      }

      .section_img {
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 258px;
      }
    }

    .fade-leave-active {
      opacity: 0.5;
      transition: opacity 0.1s;
    }

    .fade-enter-active {
      animation: fadeIn 0.1s;
    }

    @keyframes fadeIn {
      from {
        opacity: 0.5;
      }

      to {
        opacity: 1;
      }
    }
  }

  .section5 {
    .section_pic {
      margin-left: 180px;
    }
  }

  .section6 {
    .section_wrapper {
      align-items: unset;
      flex-direction: column;
      padding-top: 75px;
      width: 100%;
    }

    .container {
      height: 100%;
      justify-content: center;
      padding: 0;
    }

    .section6_title {
      @include font-size-bold-40;

      margin: 0;
      margin-bottom: 50px;
      text-align: center;
    }

    .section6_info {
      background: $mono_10;
      position: relative;
      padding: 100px 0;
      text-align: center;

      .merchant_activity_link {
        @include font-size-bold-40;

        color: $black;
        display: block;
        margin-bottom: 50px;
        text-decoration: none;
      }
    }

  }
}

@include RWD_1024 {
  .layout_wrapper {
    .container {
      max-width: 824px;

      .section_pic {
        height: 360px;
        width: 360px;
      }

      .swiper_arrow {
        height: 40px;
        width: 40px;
      }
    }

    .section1 {
      .container {
        padding-top: 100px;
      }

      .section_info {
        margin-right: 6px;

        .section1_title {
          margin-top: 0;
        }

        .section1_description {
          @include font-size-24;
        }
      }

      .section_pic {
        &::before {
          height: 360px;
          left: 360px;
        }
      }
    }

    .section2 {
      .section2_arrow_right {
        right: -54px;
      }
    }

    .section3 {
      .section_pic {
        margin-left: 104px;
      }

      .special_section3_pic {
        width: 360px;
        height: 266px;

        .special_section3_img_size {
          width: 100%;
        }
      }
    }

    .section4 {
      .section_wrapper {
        &:not(:last-child) {
          margin-bottom: 150px;
        }
      }

      .section_pic {
        height: 360px;
        margin-right: 100px;
        width: 360px;

        .section_img {
          width: 205px;
        }
      }

      ::v-deep(.swiper-container) {
        height: 360px;
      }

      .section4_scrollbar {
        height: 180px;
        right: -58px;

        ::v-deep(.swiper-scrollbar-drag) {
          height: 90px !important;
        }
      }
    }

    .section5 {
      .section_pic {
        margin-left: 105px;
      }
    }

    .section6 {
      .section6_info {

      }
    }
  }
}

@include RWD_768 {
  .layout_wrapper {
    .container {
      max-width: 668px;

      .section_wrapper {
        flex-direction: column;
        width: 100%;
      }

      .section_info {
        text-align: center;
        width: 373px;

        .section_info_title {
          @include font-size-bold-24;

          margin-top: 0;
          margin-bottom: 10px;
        }

        .section_info_list {
          li {
            &:not(:last-child) {
              margin-bottom: 10px;
            }
          }
        }
      }

      .section_pic {
        height: 290px;
        margin: 0px 0px 50px 0px;
        width: 290px;
      }

      .swiper_arrow {
        height: 30px;
        width: 30px;
      }
    }

    .section1 {
      .container {
        padding-top: 50px;
      }

      .section_wrapper {
        align-items: flex-start;
        flex-direction: row;
      }

      .section_info {
        width: 280px;
        margin-right: 3px;
        text-align: left;

        .section1_title {
          @include font-size-bold-40;

          line-height: 45px;
        }

        .section1_description {
          line-height: 30px;
          margin-bottom: 50px;
        }
      }

      .section_pic {
        &::before {
          height: 290px;
          left: 290px;
        }
      }
    }

    .section2 {
      .section_wrapper {
        flex-direction: row;
      }

      .section_pic {
        margin: 0px 50px 0px 0px;
      }

      .section_info {
        text-align: left;
        width: 248px;
      }

      .section2_arrow_right {
        right: 0;
      }
    }

    .section3 {
      .section_pic {
        height: 370px;
        width: 370px;
      }

      .section_info {
        order: 1;

        .section_info_title {
          margin-bottom: 20px;
        }
      }

      .special_section3_pic {
        width: 370px;
        height: 274px;

        .special_section3_img_size {
          width: 100%;
        }
      }
    }

    .section4 {
      .container {
        flex-direction: column;
        justify-content: center;
      }

      ::v-deep(.swiper-container) {
        height: 100%;

        .swiper-slide {
          &:not(:last-child) {
            margin-bottom: 0px;
          }
        }
      }

      .swiper_arrow_right {
        display: block;
        top: 236px;
      }

      .section_pic {
        height: 350px;
        position: relative;
        width: 300px;

        .section4_num {
          color: $primary_40;
          display: block;
          font-size: 74px;
          font-weight: 700;
          left: -130px;
          line-height: 107px;
          position: absolute;
          top: 120px;

          &:after{
             display: none
          }
        }

        .section_img {
          width: 168px;
        }
      }

      .section_info {
        width: 373px;

        .section4_num {
          display: none;
        }
      }

      .section4_scrollbar {
        display: none;
      }
    }

    .section5 {
      .section_info {
        order: 1;
      }
    }

    .section6 {
      .intro_para {
        margin-bottom: 0;
      }
    }
  }
}

@include RWD_414 {
  .layout_wrapper {
    .container {
      max-width: 100%;
      padding: 50px 30px;

      .section_wrapper {
        align-items: center;
        flex-direction: column;
      }

      .section_info {
        width: 100%;
        order: 2;
        text-align: center;

        .section_info_title {
          @include font-size-bold-24;

          margin-top: 30px;
          margin-bottom: 10px;
          text-align: center;
        }
      }

      .section_pic {
        height: 270px;
        margin: 0px 0px 30px 0px;
        margin-bottom: 30px;
        width: 270px;
      }

      .swiper_arrow {
        display: block !important;
        height: 30px;
        top: 170px;
        transform: translateY(0);
        width: 30px;

        &.swiper_arrow_left {
          left: 30px;
        }

        &.swiper_arrow_right {
          right: 30px;
        }
      }

      ::v-deep(.action_btn_wrapper) {
        width: 100% !important;
      }
    }

    .section1 {
      .container {
        flex-direction: column-reverse;
        padding-top: 20px;
      }

      .section_info {
        width: 100%;
        margin-right: 0;

        .section1_title {
          @include font-size-bold-40;

          margin-bottom: 10px;
          text-align: center;
        }

        .section1_description {
          @include font-size-18;

          margin-bottom: 50px;
          text-align: center;
        }
      }

      .section_pic {
        &::before {
          display: none;
        }
      }
    }

    .section2 {
      .section_pic {
        text-align: center;
      }

      .section_wrapper {
        .section_info {
          .section_info_title {
            margin-top: 0px;
          }
        }
      }
    }

    .section3 {
      .section_info {
        .section_info_list {
          li {
            &:not(:last-child) {
              margin-bottom: 20px;
            }
          }
        }

        .section_info_title {
          margin: 0px 0px 30px;
        }
      }

      .special_section3_pic {
        width: 255px;
        height: 185px;

        .special_section3_img_size {
          width: 100%;
        }
      }
    }

    .section4 {
      ::v-deep(.swiper-container) {
        height: 100%;
      }

      .container {
        .swiper_arrow {
          top: calc(159.5px + 50px);
          transform: translateY(-50%);
        }
      }

      .section_info {
        .section_info_title {
          margin-top: 0px;
        }
      }

      .section_pic {
        .section4_num {
          display: none;
        }

        .section_img {
          width: 153px;
        }

        &.special_section4_pic {
          height: 319px;
        }

      }
    }

    .section5 {
      .section_info {
        .section_info_title {
          margin-top: 0px;
        }
      }
    }

    .section6 {
      .section_wrapper {
        padding-top: 50px;

        .section6_title {
          margin: 0px 0px 30px 30px;
          text-align: left;
        }
      }

      .section6_info {
        padding: 50px 0;
      }
    }
  }
}

@media screen and (max-width: 413px) {
  #app .layout_wrapper {
    .swiper_arrow {
      &.swiper_arrow_left {
        left: 15px;
      }

      &.swiper_arrow_right {
        right: 15px;
      }
    }
  }
}
</style>
